<template>
  <transition name="fade">
    <popup
      :show.sync="is_popup_kuai_show"
      width="500px"
      height="420px"
      @on-close="close"
    >
      <h2>商品信息</h2>
      <div class="form">
        <div class="form-group">
          <div class="form-label">类目：</div>
          <div class="form-control">
            <Cascader
              class="input1"
              :disabled="product.kuai_item_id?true:false"
              @on-change="changeCategory"
              filterable
              :data="kuaiCategory"
              v-model="kuaiForm.categoryValue"
              placeholder="请选择类目"
            ></Cascader>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">商品主图:</div>
          <div class="form-control">
            <div class="demo-upload-list" v-for="(item,index) in uploadList" :key="index">
                <img :src="item" fit="cover" width="100%" height="100%" />
                <div class="demo-upload-list-cover">
                    <Icon type="ios-trash-outline" @click="handleRemove(index)"></Icon>
                </div>
            </div>
            <Upload
                ref="upload"
                :show-upload-list="false"
                :on-success="handleSuccess"
                :format="['jpg','jpeg','png']"
                :max-size="2048"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                multiple
                type="drag"
                :action="upload_url"
				:data="{dir:'template'}"
                style="display: inline-block;width:58px;">
                <div style="width: 58px;height:58px;line-height: 58px;">
                    <Icon type="ios-camera" size="20"></Icon>
                </div>
            </Upload>
          </div>
          <div style=" color: #808080;font-size: 12px;">
                最多上传9张图片,最小高度不低于600像素,单张图片大小不超过2M，支持png/jpeg/jpg格式
            </div>
        </div>
        
        
        
        <div class="form-group">
          <div class="form-label">运费模版：</div>
          <div class="form-control">
            <Select
              v-model="kuaiForm.expressTemplateId"
              style="max-width: 300px; width: 300px; height: 48px"
              filterable
              label-in-value
              @on-change="expressTemplateChange"
            >
              <Option
                v-for="(option, index) in shop_info.template"
                :value="option.id"
                :key="index"
                >{{ option.name }}</Option
              >
            </Select>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">退款规则：</div>
          <div class="form-control">
            <Select
              v-model="kuaiForm.refundRule"
              style="max-width: 300px; width: 300px; height: 48px"
              filterable
              label-in-value
              @on-change="refundRuleChange"
            >
              <Option
                v-for="(option, index) in categoryConfig.refundRuleList"
                :value="option.value"
                :key="index"
                >{{ option.name }}</Option
              >
            </Select>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">服务承诺：</div>
          <div class="form-control">
            <label
              style="mrgin-right: 10px"
              v-for="(v, k) in categoryConfig.servicePromise"
              :key="`dpc1` + k"
            >
              <input
                type="checkbox"
                v-model="v.value"
                :disabled="v.required"
              />{{ v.name }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">商品属性：</div>
        </div>
        <div
          class="form-group"
          v-for="(v, k) in kuaiPropConfigs"
          :key="`dpc1` + k"
        >
          <div class="form-label">{{ v.propName }}:</div>
          <div class="form-control">
            <label @click="propInputIndex = k">
              <Select
                v-if="v.propInputType == 'RADIO'"
                v-model="v.value"
                style="max-width: 300px; width: 300px"
                filterable
                @on-query-change="propSearch"
                :loading="loading"
                label-in-value
                @on-select="propChange($event, k)"
              >
                <Option
                  v-for="(option, index) in v.prePropValues"
                  :value="option.propValueId"
                  :key="index"
                  >{{ option.propValue }}</Option
                >
              </Select>
              <Select
                v-if="v.propInputType == 'CHECKBOX'"
                v-model="v.value"
                multiple
                filterable
                @on-query-change="propSearch"
                :loading="loading"
                style="max-width: 300px; width: 300px"
                label-in-value
                @on-select="propChange($event, k)"
              >
                <Option
                  v-for="(option, index) in v.prePropValues"
                  :value="option.propValueId"
                  :key="index"
                  >{{ option.propValue }}</Option
                >
              </Select>
              <Input
                style="max-width: 300px; width: 300px"
                v-model="v.textPropValue"
                v-if="v.propInputType == 'TEXT'"
              />
            </label>
          </div>
        </div>
        <div class="btn-submit" @click="submit()">提交快手平台</div>
      </div>
    </popup>
  </transition>
</template>
<script>
import { AddProduct, GetMyShopList, GetShopInfo,GetCateConfig,GetCategoryPropSearch } from "@/api/open";
import Popup from "@/components/Popup.vue";
import kuaiCategory from "@/utils/kuaiCategory.js";
export default {
  name: "KuaiEdit",
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      },
    },
    shop_id: {
      type: Number,
      default: 0
    },
  },
  components: {
    Popup,
  },
  data() {
    return {
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      is_popup_kuai_show:false,
      shop_info: {},
      kuaiCategory,
      kuaiForm: {
        refundRule: "",
        servicePromise: "",
        categoryId: "",
        expressTemplateId: "",
        categoryValue:[]
      },
      categoryConfig:{
        brokenRefund: 1,
        allergyRefund: 1,
        refundRuleList: [],
        freshRotRefund: 1
      },
      kuaiPropConfigs:[],
      propInputIndex:0,
      loading:false,
     
      uploadList: []
    };
  },
  computed: {
    
  },
  mounted() {},
  methods: {
    handleRemove (index) {
        this.uploadList.splice(index, 1);
    },
    handleMaxSize (file) {
        this.$Notice.warning({
            title: '文件太大了',
            desc: '单张图片大小不超过2M'
        });
    },
    handleBeforeUpload () {
        const check = this.uploadList.length < 9;
        if (!check) {
            this.$Notice.warning({
                title: '最多上传9张图片.'
            });
        }
        return check;
    },
    handleSuccess(response, file, fileList) {
   
        this.uploadList.push(response.data.url)
	},
    close() {
      this.is_popup_kuai_show = false;
    },
    show() {
        
        GetShopInfo({
            shop_id: this.shop_id,
        }).then((response)=>{
            this.shop_info = response.data;
            this.is_popup_kuai_show = true
            if(this.product.kuai_item_id) {
                this.uploadList = this.product.kuai_product_data.originImgUrl
                this.kuaiForm.categoryValue = this.product.kuai_product_data.categoryValue || [1524, 1526]
                this.kuaiForm.expressTemplateId = this.product.kuai_product_data.expressTemplateId
                this.kuaiForm.refundRule = this.product.kuai_product_data.serviceRule.refundRule
                this.getCateConfig()
            }
      }).catch(err=>{
          this.$layer.msg(err.msg);
      });
    },
    submit() {
   
      if (this.kuaiForm.categoryValue.length === 0) {
        return this.$layer.msg("请选择类目");
      }
      if (!this.kuaiForm.expressTemplateId) {
        return this.$layer.msg("请选择运费模版");
      }
      if (!this.kuaiForm.refundRule) {
        return this.$layer.msg("请选择退款规则");
      }
      let msg = false
      let itemPropValues = []

      this.kuaiPropConfigs.forEach((i)=>{
          itemPropValues.push({
            propId:i.propId,
            propName:i.propName,
            sortNum:i.sortNum,
            propType:2,//商品属性
            propId:i.propId,
            propInputType:i.propInputType,
            textPropValue:i.textPropValue ?i.textPropValue:'',
            radioPropValue:i.radioPropValue ?i.radioPropValue:{},
            checkBoxPropValuesList:i.checkBoxPropValuesList ?i.checkBoxPropValuesList:[],
          })
          if(!i.value) {
            msg = i.propName+'属性必填'
          }
      })
    
      if (msg) {
        return this.$layer.msg(msg);
      }
      
      const servicePromise = this.categoryConfig.servicePromise.reduce(
        (acc, item) => {
          acc[item.code] = item.value;
          return acc;
        },
        {}
      );
      let param = {
        refundRule: this.kuaiForm.refundRule,
        expressTemplateId: this.kuaiForm.expressTemplateId,
        servicePromise,
        categoryId: this.kuaiForm.categoryValue[this.kuaiForm.categoryValue.length - 1],
        shop_id: this.shop_id,
        uuid: this.product.uuid,
        itemPropValues,
        categoryValue:this.kuaiForm.categoryValue,
        kuaiImageList: this.uploadList
      };

      AddProduct(param)
        .then((response) => {
          this.$emit('getProduct')
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        })
        .finally(() => {
          this.is_popup_kuai_show = true;
        });
    },
    
    async getCateConfig() {
        if(this.kuaiForm.categoryValue.length == 0) {
            return 
        }
        let { data } = await GetCateConfig({
            categoryId:this.kuaiForm.categoryValue[this.kuaiForm.categoryValue.length - 1],
            shop_id: this.shop_id,
        })
        // 必填商品属性
        this.kuaiPropConfigs = data.propConfigs.filter((i)=>{
          return i.required
        })
        this.categoryConfig = data.categoryConfig

        //获取属性值
        await Promise.all(this.kuaiPropConfigs.map(async (i) => {
            i.prePropValues = await this.getCategoryPropSearch(i);
            if(this.product.kuai_item_id) {
              let item = this.product.kuai_product_data.itemPropValues.find((prop)=>{
                return prop.propId == i.propId
              })
              if(item) {
                if(item.propInputType == 'RADIO') {
                   i.radioPropValue = item.radioPropValue
                   i.value = item.radioPropValue.propValueId
                }
                if(item.propInputType == 'TEXT') {
                  i.value = item.textPropValue
                  i.textPropValue = item.textPropValue
                }
                if(item.propInputType == 'CHECKBOX') {
                  i.checkBoxPropValuesList = item.checkBoxPropValuesList
                  i.value = item.checkBoxPropValuesList.map((prop)=>{
                    return prop.propValueId
                  })
                }
              }
            }
        }));
        console.error(this.kuaiPropConfigs)
        this.$forceUpdate()
    },
    async getCategoryPropSearch(i,propValue='') {
      return new Promise((resolve,reject) => {
        GetCategoryPropSearch({
          shop_id: this.shop_id,
          categoryId:this.kuaiForm.categoryValue[this.kuaiForm.categoryValue.length - 1],
          propId:i.propId,
          propValue
        }).then((response) => {
          resolve(response.data.propValues)
        })
      })
    },
    propSearch(query) {
      console.error(this.propInputIndex,'propSearch')
      // this.loading = true
      // this.getCategoryPropSearch(this.kuaiPropConfigs[this.propInputIndex],query).then((res)=>{
      //   this.kuaiPropConfigs[this.propInputIndex].prePropValues =  res
      //   this.$forceUpdate()
      //   this.loading = false;
      // });
    },
    propChange(e,index) {
      console.error(e,index,'propChange')
       if(e){
        if(this.kuaiPropConfigs[index].propInputType == 'RADIO') {
            this.kuaiPropConfigs[index].radioPropValue = {
              propValueId:e.value,
              propValue:e.label
            }
        }
        if(this.kuaiPropConfigs[index].propInputType == 'CHECKBOX') {
            let arr = []
            e.forEach((i)=>{
              arr.push({
                propValueId:i.value,
                propValue:i.label
              })
            })
            this.kuaiPropConfigs[index].checkBoxPropValuesList = arr
        }
       }
    },
    changeCategory(e) {
      console.log(e)
      this.kuaiForm.categoryValue = e
      this.getCateConfig()
    },
    refundRuleChange(e) {
      console.log(e)
    },
    expressTemplateChange(e) {
      console.log(e)
    },
  },
};
</script>
<style lang="scss" scoped>
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
